import { render, staticRenderFns } from "./discover-more.vue?vue&type=template&id=d19df07e&scoped=true&"
import script from "./discover-more.vue?vue&type=script&lang=ts&"
export * from "./discover-more.vue?vue&type=script&lang=ts&"
import style0 from "./discover-more.vue?vue&type=style&index=0&id=d19df07e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19df07e",
  null
  
)

export default component.exports